module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Melissa Nathan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Melissa Nathan was born and raised in Hertfordshire and now lives in North London with her husband. A journalist for ten years, she writes novels full time and is the acclaimed author of "), _c('I', [_vm._v("The Nanny")]), _vm._v(" and "), _c('I', [_vm._v("Pride, Prejudice and Jasmin Field")]), _vm._v(".")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/15b4aUl/tc-custom/9780061853036.jpg?1731208371905",
      "alt": "This image is the cover for the book Nanny"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Nanny\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("When a smalltown girl takes a nanny job in London, she must learn to navigate family dysfunction and romantic temptation in this new adult novel.")]), _c('br'), _c('br'), _vm._v("Twenty-three-year-old Jo Green knows that if she has to spend one more night in ultra-provincial Niblet-Upon-Avon she’ll go completely bonkers! So she answers an ad in the paper, bids her devoted boyfriend Shaun adieu, and heads off to the big city. With a new job that offers excitement, a cool car, and her own suite, how can she go wrong?"), _c('br'), _c('br'), _vm._v("Then she meets the Fitzgeralds—Dick and Vanessa and their unruly brood of rugrats who have suddenly been entrusted into Jo’s care. There’s eight-year-old “psycho-babe” Cassandra; the bloodthirsty six-year-old Zak; and timid little Tallulah."), _c('br'), _c('br'), _vm._v("Then things get "), _c('i', [_vm._v("really")]), _vm._v(" complicated with the arrival of Josh, Dick’s handsome older son from his first marriage. Now forced to share her room with Josh, Jo is caught between a long-distance beau who’s still in the picture and a sexy possibility sleeping just a foot away!\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0